import React, { useEffect, useMemo } from 'react';

import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Translate } from 'react-localize-redux';

import Button from '@fd/ui/Button/Button';
import ErrorComponent from '@fd/ui/ErrorComponent';
import Loading from '@fd/ui/Loading';

import { languageActions } from '../../actions/language.actions';
import { ReactComponent as FlipdishLogo } from '../../assets/images/FlipdishLogo.svg';
import { store } from '../../helpers/store';
import { getBridgeLanguage, getSafeFlipdishAppTarget } from './mobileOAuthBridge.utils';

const FullScreen = styled(Grid)({
  minHeight: '100vh',
  padding: 24,
});

const MobileOAuthBridge: React.FC = () => {
  const appTarget = useMemo(() => getSafeFlipdishAppTarget(window.location.search), []);
  const lang = useMemo(() => getBridgeLanguage(window.location.search), []);

  useEffect(() => {
    if (lang) {
      store.dispatch(languageActions.setLanguage(lang) as any);
    }
  }, [lang]);

  useEffect(() => {
    if (appTarget) {
      window.location.assign(appTarget);
    }
  }, [appTarget]);

  if (!appTarget) {
    return (
      <FullScreen container justifyContent="center" alignItems="center">
        <ErrorComponent
          title="MobileOauthBridge_invalid_title"
          subtitle="MobileOauthBridge_invalid_subtitle"
        />
      </FullScreen>
    );
  }

  return (
    <FullScreen
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      spacing={2}
    >
      <Grid item>
        <FlipdishLogo data-fd="mobile-oauth-bridge-logo" />
      </Grid>
      <Grid item>
        <Loading />
      </Grid>
      <Grid item>
        <Typography variant="h5" align="center">
          <Translate id="MobileOauthBridge_returning_title" />
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="body1" align="center" color="textSecondary">
          <Translate id="MobileOauthBridge_returning_subtitle" />
        </Typography>
      </Grid>
      <Grid item>
        <Button fdKey="open-flipdish-app" variant="contained" color="primary" href={appTarget}>
          <Translate id="MobileOauthBridge_open_app" />
        </Button>
      </Grid>
    </FullScreen>
  );
};

export default MobileOAuthBridge;
